export default __webpack_public_path__ + "static/media/carousel-03-ropa-bebes-pt.a8d7fa6f.png";